import { AlertTriangle } from 'lucide-react';
import { Button } from './Button';

/** Einheitlicher Fehlerzustand mit optionalem „Erneut versuchen". */
export function ErrorState({
  message = 'Etwas ist schiefgelaufen.',
  onRetry,
}: {
  message?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex animate-fade-in flex-col items-center gap-3 p-8 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-pill bg-red-50 text-red-500 ring-4 ring-red-50/50">
        <AlertTriangle size={24} />
      </div>
      <p className="text-sm text-kalkuel-muted">{message}</p>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          Erneut versuchen
        </Button>
      )}
    </div>
  );
}
